export type CommunicationType = 'call' | 'sms' | 'email' | 'note' | 'meeting';
export type CommunicationDirection = 'inbound' | 'outbound';
export type CommunicationSource = 'lead_activity' | 'sms_message' | 'customer_communication' | 'call_log';

export interface Communication {
  id: string;
  source: CommunicationSource;
  type: CommunicationType;
  direction: CommunicationDirection | null;
  timestamp: string;

  // Contact info
  customer_name: string;
  customer_phone: string;
  customer_id?: string;
  lead_id?: string;
  job_id?: string;
  lead_number?: string;

  // Content
  content?: string;
  subject?: string;
  outcome?: string;

  // Attribution
  campaign_name?: string;
  /** CTM tracking pool / label from webhook (call_logs.metadata.tracking_label) */
  tracking_label?: string;
  source_name?: string; // Marketing source (e.g., "Google Ads", "Bing Organic")
  tracking_number?: string;
  agent_name?: string;
  agent_id?: string;

  // Call-specific
  duration_seconds?: number;
  talk_time_seconds?: number;
  recording_available?: boolean;
  recording_activity_id?: string;
  recording_url?: string;
  call_id?: string; // CTM SID / external_call_id
  is_new_caller?: boolean;
  call_score?: number; // 1-5 star rating

  // Metadata
  metadata?: Record<string, unknown>;
}

export interface CommunicationFilters {
  type: CommunicationType | 'all';
  direction: CommunicationDirection | 'all';
  dateRange: 'today' | 'yesterday' | 'last7days' | 'last30days' | 'custom';
  startDate?: Date;
  endDate?: Date;
  search: string;
  csrId?: string;
}

export const DEFAULT_FILTERS: CommunicationFilters = {
  type: 'all',
  direction: 'all',
  dateRange: 'last7days',
  search: '',
};
